import React, { useEffect } from "react";

export const Testimonials = () => {
  useEffect(() => {
    // Load Featurable embed script only once
    const existing = document.querySelector(
      'script[src="https://cdn.featurable.com/widget/v2/embed.js"]'
    );
    if (existing) return;
    const script = document.createElement("script");
    script.src = "https://cdn.featurable.com/widget/v2/embed.js";
    script.defer = true;
    script.charset = "UTF-8";
    document.body.appendChild(script);
  }, []);

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="bg-slate-50 border-y border-slate-200"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-14 py-24 md:py-32">
        <div className="max-w-2xl mb-12">
          <div className="overline text-blue-600 mb-6">Client voices</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-light tracking-tighter text-slate-950 text-balance">
            Trusted by homeowners, developers and businesses across the UAE.
          </h2>
          <p className="mt-6 text-slate-600 text-base md:text-lg leading-relaxed">
            Verified Google reviews from real clients, updated live from Google Maps.
          </p>
        </div>

        {/* Featurable Google Reviews widget */}
        <div
          id="featurable-22d034a4-3fb3-4615-b0d2-888653467e9b"
          data-featurable-async
          data-testid="featurable-google-reviews"
          className="min-h-[280px]"
        />
      </div>
    </section>
  );
};
